module.exports = __webpack_public_path__ + "img/logo-recuperi-2400.750c1bcf.png";